import * as React from "react";
function SvgClinic(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <g clipPath="url(#clinic_svg__clip0_1297_7080)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.707 1.293a1 1 0 00-1.414 0l-10 10 1.414 1.414L4 11.414V20a2 2 0 002 2h12a2 2 0 002-2v-8.586l1.293 1.293 1.414-1.414-10-10zM18 9.414l-6-6-6 6V20h12V9.414zM11 10v3H8v2h3v3h2v-3h3v-2h-3v-3h-2z"
                    fill="currentcolor"
                />
            </g>
            <defs>
                <clipPath id="clinic_svg__clip0_1297_7080">
                    <path fill="#fff" d="M0 0h24v24H0z" />
                </clipPath>
            </defs>
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgClinic);
export default ForwardRef;
